import React from 'react';
import Sugar from 'sugar';

import InlineDropdown from '../modules/InlineDropdown';


Sugar.extend();


const sortOptions = [
  {
    field: 'income',
    desc: true,
    title: "Income, Highest To Lowest"
  },

  {
    field: 'income',
    desc: false,
    title: "Income, Lowest To Highest"
  },


  {
    field: 'debt',
    desc: true,
    title: "Debt, Highest To Lowest"
  },
  {
    field: 'debt',
    desc: false,
    title: "Debt, Lowest To Highest"
  },


  {
    field: 'school',
    desc: false,
    title: "School Name, A-Z"
  },


  {
    field: 'school',
    desc: true,
    title: "School Name, Z-A"
  },
];
//
// const getStringForSortOption = ( { field, desc } ) =>
// {
//   const descString = desc ? "Highest To Lowest" : "Lowest To Highest";
//   return `${field.titleize()}, ${ descString }`;
// }

function SearchSort( {sort, onSelectSort} ) {

  const selected = sortOptions.findIndex( option => Object.isEqual(option, sort) );
  const dropwdownOptions = sortOptions.map( (option, i) => ({ title: option.title, value: i }));

  const handleSelect = value => {
    onSelectSort( sortOptions[value] )
  }


  return (
    <div className="search-sort">
      <span className="label">SORT BY:&nbsp;</span>
      <InlineDropdown
        className="drop"
        options={ dropwdownOptions }
        selected={ selected }
        onSelect={ handleSelect }
        />
    </div>
  );
}

SearchSort.defaultProps = {
  sort: {
    field: 'income',
    desc: true,
    title: "Income, Highest To Lowest"
  }
}

export default SearchSort;
